import type { Room } from "building-types/rooms/roomTypes";
import type { Table } from "common/data/table";

export function roomsOnLevel(level: string, rooms: Table<Room>, roomsByLevel: Table<string[]>): Room[] {
  const ids = roomsByLevel[level];
  if (!ids) {
    return [];
  }
  const res = new Array<Room>(ids.length);
  for (let i = 0, l = ids.length; i < l; i++) {
    res[i] = rooms[ids[i]];
  }
  return res;
}
